import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { Container, Row, Col, Card, Badge, Spinner, Breadcrumb } from 'react-bootstrap';
import excelFile from '../assets/pet-insurance.xlsx';
import { Helmet } from 'react-helmet-async';

export default function PetInsuranceInIndia() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Route: /pet-shop/:areaName
  const { categories } = useParams();
  const area = categories;
//console.log(area);
  useEffect(() => {
    fetch(excelFile)
      .then((res) => res.arrayBuffer())
      .then((buffer) => {
        const workbook = XLSX.read(buffer, { type: 'buffer' });
        const firstSheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[firstSheetName];

        const parsedRows = XLSX.utils.sheet_to_json(sheet);
        setData(parsedRows);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error loading Excel file:', err);
        setLoading(false);
      });
  }, []);

  const createSlug = (text) => (text ? String(text).toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-') : '');

  const currentAreaData = data.find(
    (row) => createSlug(row.categories) === createSlug(area)
  );
// console.log("Data", currentAreaData);
  // Dynamic Meta Title & Meta Description Setup
  // useEffect(() => {
  //   if (currentAreaData) {
  //     if (currentAreaData.Meta_title) {
  //       document.title = currentAreaData.Meta_title;
  //     }

  //     if (currentAreaData.Meta_desc) {
  //       let metaDescription = document.querySelector('meta[name="description"]');
  //       if (!metaDescription) {
  //         metaDescription = document.createElement('meta');
  //         metaDescription.setAttribute('name', 'description');
  //         document.head.appendChild(metaDescription);
  //       }
  //       metaDescription.setAttribute('content', currentAreaData.Meta_desc);
  //     }
  //   }
  // }, [currentAreaData]);

  if (loading) {
    return (
      <Container className="d-flex flex-column align-items-center justify-content-center min-vh-100">
        <Spinner animation="border" style={{ color: '#ff4e00' }} />
        <p className="mt-3 fw-semibold">Loading city details...</p>
      </Container>
    );
  }
//console.log(areaName);
  if (!currentAreaData) {
    return (
      <Container className="py-5 text-center">
        <Card className="p-5 border-0 shadow-sm rounded-4">
          <h2 className="fw-bold text-dark">Data Not Found</h2>
          <p className="mb-0">We couldn't find any pet insurance in India data for "{categories}".</p>
        </Card>
      </Container>
    );
  }

  const formatDirectoryListings = (htmlContent) => {
    if (!htmlContent) return '';
    
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    const h2Tag = doc.querySelector('h2');
    
    if (h2Tag) {
      const originalCity = h2Tag.textContent.trim();
      h2Tag.textContent = `Featured service providers - ${originalCity}`;
    }
    
    return doc.body.innerHTML;
  };
  // Place this helper function outside or above your component
const renderFormattedContent = (content) => {
  if (!content) return { __html: '' };

  let htmlContent = String(content);

  // Regex to detect Markdown table patterns (| col1 | col2 |)
  const markdownTableRegex = /\|(.+)\|[\r\n]+\|[-:| ]+\|[\r\n]+((?:\|.+\|[\r\n]*)+)/g;

  htmlContent = htmlContent.replace(markdownTableRegex, (match, headerRow, bodyRows) => {
    // Parse headers
    const headers = headerRow
      .split('|')
      .map((h) => h.trim())
      .filter((h) => h.length > 0);

    const ths = headers.map((h) => `<th>${h}</th>`).join('');

    // Parse rows
    const rows = bodyRows
      .trim()
      .split('\n')
      .map((row) => {
        const cells = row
          .split('|')
          .map((c) => c.trim())
          .filter((c) => c.length > 0);

        if (cells.length === 0) return '';
        const tds = cells.map((c) => `<td>${c}</td>`).join('');
        return `<tr>${tds}</tr>`;
      })
      .join('');

    return `
      <div className="table-responsive">
        <table>
          <thead><tr>${ths}</tr></thead>
          <tbody>${rows}</tbody>
        </table>
      </div>
    `;
  });

  return { __html: htmlContent };
};

// const renderSlashFix = (htmlString) => {
//   if (!htmlString) return { __html: "" };

//   // 1. Remove any accidental escape backslashes coming from Excel/CSV export
//   let cleanedString = htmlString.replace(/\\/g, '');

//   // 2. Wrap plain text blocks or paragraphs if your excel data doesn't have <p> tags
//   // (Optional: only do this if your text lacks surrounding HTML tags)
//   if (!cleanedString.trim().startsWith('<')) {
//     cleanedString = `<p>${cleanedString}</p>`;
//   }

//   return { __html: cleanedString };
// };
// const renderPipeFix = (text) => {
//   if (!text) return { __html: '' };
  
//   // Replace all instances of '|' (with optional surrounding spaces) with a line break
//   const formattedText = text.replace(/\s*\|\s*/g, '<br />');
  
//   return { __html: formattedText };
// };
const renderSlashFix = (htmlString) => {
  if (!htmlString) return { __html: "" };

  // 1. Remove any accidental escape backslashes coming from Excel/CSV export
  let cleanedString = htmlString.replace(/\\/g, '');

  // 2. Replace all instances of '|' (with optional surrounding spaces) with a line break
  cleanedString = cleanedString.replace(/\s*\|\s*/g, '<br />');

  // 3. Automatically add a line break before "Value Proposition" (case-insensitive)
  cleanedString = cleanedString.replace(/\.\s*(Value Proposition:)/gi, '.<br /><br />$1');

  // 4. Wrap in <p> tags if the string doesn't start with an HTML tag
  if (!cleanedString.trim().startsWith('<')) {
    cleanedString = `<p>${cleanedString}</p>`;
  }

  return { __html: cleanedString };
};


// --- Smart Region-Matched Random Nearby Cities Generator (Returns Objects) ---
  const getRandomNearbyCities = () => {
    if (!data || data.length === 0 || !currentAreaData?.categories) return [];

    const getRegion = (str) => {
      if (!str) return '';
      const parts = str.split(',');
      return parts.length > 1 ? parts[parts.length - 1].trim().toLowerCase() : str.trim().toLowerCase();
    };

    const currentRegion = getRegion(currentAreaData.categories);

    let filtered = data.filter((row) => {
      if (!row.categories) return false;
      const isSameRegion = getRegion(row.categories) === currentRegion;
      const isNotCurrent = createSlug(row.categories) !== createSlug(area);
      return isSameRegion && isNotCurrent;
    });

    if (filtered.length < 4) {
      const otherCities = data.filter((row) => row.categories && createSlug(row.categories) !== createSlug(area));
      filtered = [...filtered, ...otherCities.filter(c => !filtered.includes(c))];
    }

    const shuffled = [...filtered].sort(() => 0.5 - Math.random());
    const selected = shuffled.slice(0, 4);

    // Map to objects containing name and slug
    return selected.map((item) => ({
      name: item.categories,
      slug: createSlug(item.categories),
    }));
  };

  return (
    <>
    {/* {console.log(currentAreaData?.Meta_title)} */}
    <Helmet>
      <title>
        {currentAreaData?.title ||
          "Pet Insurance In India"}
      </title>
      <meta
        name="description"
        content={
          currentAreaData?.['meta desc'] ||
          "Pet Insurance In India"
        }
      />
    </Helmet>
    <div style={{ backgroundColor: '#fdfbfb', minHeight: '100vh', padding: '40px 0' }}>
      {/* Modern Custom Scoped Styles */}
      <style>{`
      .custom-breadcrumb .breadcrumb-item + .breadcrumb-item::before {
          color: #9ca3af;
        }
        .custom-breadcrumb a {
          color: #6b7280;
          text-decoration: none;
          font-weight: 500;
          transition: color 0.2s ease;
        }
        .custom-breadcrumb a:hover {
          color: #ff4e00;
        }
        .custom-breadcrumb .breadcrumb-item.active {
          color: #ff4e00;
          font-weight: 600;
        }

        /* Card Hover & Styling */
        .custom-card {
          border-radius: 20px !important;
          background: #ffffff;
          border: 1px solid rgba(0, 0, 0, 0.05) !important;
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
          box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.05) !important;
          position: relative;
          overflow: hidden;
        }
        .custom-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 20px 40px -15px rgba(255, 78, 0, 0.12) !important;
          border-color: rgba(255, 78, 0, 0.2) !important;
        }
        /* Card Hover & Styling */
        .custom-card {
          border-radius: 20px !important;
          background: #ffffff;
          border: 1px solid rgba(0, 0, 0, 0.05) !important;
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
          box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.05) !important;
          position: relative;
          overflow: hidden;
        }
        .custom-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 20px 40px -15px rgba(255, 78, 0, 0.12) !important;
          border-color: rgba(255, 78, 0, 0.2) !important;
        }
        
        /* Excel HTML Elements Custom Styling */
        .excel-content h2 {
          color: #111827;
          font-size: 1.3rem;
          font-weight: 800;
          margin-top: 0;
          margin-bottom: 1.25rem;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .excel-content h2::before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 1.2rem;
          background: #ff4e00;
          border-radius: 4px;
        }
        .excel-content.faq p strong {
          color: #111827;
          font-size: 1.05rem;
          font-weight: 700;
          margin-top: 1.5rem;
          margin-bottom: 0.5rem;
          background: #fff5f0;
          padding: 8px 14px;
          border-radius: 8px;
          border-left: 3px solid #ff4e00;
        }
        .excel-content ul {
          list-style: disclosure-closed;
          padding-left: 1rem;
          margin-bottom: 0;
        }
        .excel-content ul li {
          position: relative;
          // padding-left: 1.75rem;
          margin-bottom: 0.85rem;
          // color: #4b5563;
          line-height: 1.6;
        }
        // .excel-content ul li::before {
        //   content: '✓';
        //   position: absolute;
        //   left: 0;
        //   top: 2px;
        //   display: flex;
        //   align-items: center;
        //   justify-content: center;
        //   width: 20px;
        //   height: 20px;
        //   background-color: #fff1eb;
        //   color: #ff4e00;
        //   font-size: 0.75rem;
        //   font-weight: 900;
        //   border-radius: 50%;
        // }
        .excel-content p {
          // color: #4b5563;
          line-height: 1.7;
          margin-bottom: 1rem;
          text-align: justify;
          text-justify: distribute;
        }
        .excel-content h3, .excel-content.faq strong {
  color: #111827;
  font-size: 1.05rem;
  font-weight: 700;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  background: #fff5f0;
  padding: 8px 14px;
  border-radius: 8px;
  border-left: 3px solid #ff4e00;
}
  .excel-content.faq strong {
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  display: block;
      }
        /* Table Design */
        .excel-content table {
          width: 100%;
          margin: 1rem 0 0 0;
          border-collapse: separate;
          border-spacing: 0;
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid #f3f4f6;
        }
        .excel-content th {
          background-color: #fff5f0;
          color: #ff4e00;
          padding: 12px 16px;
          text-align: left;
          font-weight: 700;
          font-size: 0.9rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        .excel-content td {
          padding: 14px 16px;
          border-bottom: 1px solid #f3f4f6;
          color: #374151;
          background: #ffffff;
        }
        .excel-content tr:last-child td {
          border-bottom: none;
        }
      `}</style>

      <Container>
        {/* Breadcrumb Navigation */}
        <Row className="mb-3">
          <Col lg={12}>
            <Breadcrumb className="custom-breadcrumb">
              <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/pet-insurance-in-india' }}>
                Pet Insurance in India
              </Breadcrumb.Item>
              <Breadcrumb.Item active className='text-capitalize'>
                {currentAreaData.categories || categories}
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>
        </Row>
        {/* Hero Section */}
        <Row className="mb-5">
          <Col lg={12}>
            <div 
              className="" 
              // style={{
              //   background: 'linear-gradient(180deg, #fff5f0 0%, #ffffff 100%)',
              //   border: '1px solid #ffe8df'
              // }}
            >
              <Badge 
                style={{ backgroundColor: '#ff4e00' }} 
                className="px-3 py-2 text-uppercase mb-3 rounded-pill fw-bold shadow-sm"
              >
                {currentAreaData.categories || 'Location'}
              </Badge>
              <h1 className="fw-extrabold text-dark mb-3 display-6" style={{ fontWeight: 800 }}>
                {currentAreaData.h1}
              </h1>
              <p className="text-justify">
                {currentAreaData.intro}
              </p>
            </div>
          </Col>
        </Row>

        {/* Content Cards Grid */}
        <Row className="g-4">
          {/* {currentAreaData['Directoty Listings'] && (
            <Col md={6} className="d-flex align-items-stretch">
              <Card className="custom-card w-100 p-4">
                <Card.Body 
                  className="excel-content p-0"
                  dangerouslySetInnerHTML={{ __html: currentAreaData['Directoty Listings'] }}
                />
              </Card>
            </Col>
          )} */}
          {currentAreaData['insurance plans'] && (
            <Col md={12} className="d-flex align-items-stretch">
              <Card className="custom-card w-100 p-4">

                <Card.Body className="excel-content p-0">
                   
                    <div 
                    dangerouslySetInnerHTML={renderSlashFix(currentAreaData['insurance plans'])}
                    />
                </Card.Body>
              </Card>
            </Col>
          )}

          {/* {currentAreaData['Pricing & Commercial Data'] && (
            <Col md={12} className="d-flex align-items-stretch">
              <Card className="custom-card w-100 p-4">
                <Card.Body 
                  className="excel-content p-0"
                  dangerouslySetInnerHTML={{ __html: currentAreaData['Pricing & Commercial Data'] }}
                />
              </Card>
            </Col>
          )} */}
          {currentAreaData['insurance providers'] && (
  <Col md={12} className="d-flex align-items-stretch">
    <Card className="custom-card w-100 p-4">
      <Card.Body className="excel-content p-0">
        {/* <h2 className="mb-3">Pricing & Commercial Data</h2> */}
        <div 
          
          dangerouslySetInnerHTML={renderSlashFix(currentAreaData['insurance providers'])}
        />
      </Card.Body>
    </Card>
  </Col>
)}

          {currentAreaData['premium amount and renewals'] && (
            <Col md={12} className="d-flex align-items-stretch">
                <Card className="custom-card w-100 p-4">
                <Card.Body 
                    className="excel-content p-0"
                    
                >
                    {/* <h2 className="mb-3">Health, Lineage & Legal Compliance</h2> */}
                    <div 
                    dangerouslySetInnerHTML={renderFormattedContent(currentAreaData['premium amount and renewals'])}
                    />
                </Card.Body>
                </Card>
            </Col>
            )}

          {currentAreaData['coverage inclusions and exclusions'] && (
            <Col md={12} className="d-flex align-items-stretch">
              <Card className="custom-card w-100 p-4">
                <Card.Body 
                  className="excel-content p-0"
                  
                >
                    {/* <h2 className="mb-3">Care guide & Maintenance Costs</h2> */}
                    <div 
                    
                    dangerouslySetInnerHTML={renderFormattedContent(currentAreaData['coverage inclusions and exclusions'])}
                    />
                </Card.Body>
              </Card>
            </Col>
          )}
          {currentAreaData['mandatory prerequisites'] && (
            <Col md={12} className="d-flex align-items-stretch">
              <Card className="custom-card w-100 p-4">
                <Card.Body 
                  className="excel-content p-0"
                  
                >
                    {/* <h2 className="mb-3">Care guide & Maintenance Costs</h2> */}
                    <div 
                    dangerouslySetInnerHTML={{ __html: currentAreaData['mandatory prerequisites'] }}
                    />
                </Card.Body>
              </Card>
            </Col>
          )}

          {/* {currentAreaData['Pet Supplies & Pricing'] && (
            <Col md={12} className="d-flex align-items-stretch">
              <Card className="custom-card w-100 p-4">
                <Card.Body 
                  className="excel-content p-0"
                  dangerouslySetInnerHTML={renderFormattedContent(currentAreaData['Pet Supplies & Pricing'])}
                />
              </Card>
            </Col>
          )}

          {currentAreaData['Pet-Friendly Areas Near'] && (
            <Col md={12} className="d-flex align-items-stretch">
              <Card className="custom-card p-4">
                <Card.Body 
                  className="excel-content p-0"
                  dangerouslySetInnerHTML={renderFormattedContent(currentAreaData['Pet-Friendly Areas Near'])}
                />
              </Card>
            </Col>
          )} */}
          {/* {currentAreaData['After Boarding'] && (
            <Col md={6} className="d-flex align-items-stretch">
              <Card className="custom-card p-4">
                <Card.Body 
                  className="excel-content p-0"
                  dangerouslySetInnerHTML={{ __html: currentAreaData['After Boarding'] }}
                />
              </Card>
            </Col>
          )} */}

          {/* {currentAreaData.FAQ && (
            <Col md={12}>
              <Card className="custom-card p-4">
                <Card.Body 
                  className="excel-content p-0 faq"
                  
                >
                    <h2 className="mb-3">FAQ</h2>
                    <div 
                    dangerouslySetInnerHTML={{ __html: currentAreaData.FAQ }}
                    />
                </Card.Body>
              </Card>
            </Col>
          )} */}
         {currentAreaData.FAQ && (
  <Col md={12}>
    <Card className="custom-card p-4">
      <Card.Body className="excel-content p-0 faq">
        <div 
          dangerouslySetInnerHTML={{ 
            __html: (() => {
              // 1. Clean HTML tags and stray characters
              let text = currentAreaData.FAQ
                .replace(/<[^>]*>/g, ' ')
                .replace(/^\s*\(?\s*/, '')
                .trim();

              // 2. Separate and strip section title if prepended at the start
              const titleMatch = text.match(/^Frequently Asked Questions[^\?]*?\bIn\b[^\?]*?\bIndia\b/i);
              let sectionTitle = "";

              if (titleMatch) {
                sectionTitle = titleMatch[0].trim();
                text = text.replace(titleMatch[0], "").trim();
              }

              // 3. Extract pure Question & Answer pairs cleanly
              // Matches sentences ending with '?' as Question, followed by text until next '?' as Answer
              const qaRegex = /([^?]+\?)\s*([^?]+?)(?=(?:[A-Z0-9][^?]*\?|$))/g;
              let htmlOutput = "";

              // Add main title back as a styled standalone header if present
              if (sectionTitle) {
                htmlOutput += `<h2 class="faq-main-title fw-bold mb-4">${sectionTitle}</h2>`;
              }

              let match;
              while ((match = qaRegex.exec(text)) !== null) {
                const question = match[1].trim();
                const answer = match[2].trim();

                if (question) {
                  htmlOutput += `
                    <div class="faq-item mb-4">
                      <h3 class="faq-question fw-bold mb-2">${question}</h3>
                      <p class="faq-answer text-muted mb-0">${answer}</p>
                    </div>`;
                }
              }

              return htmlOutput || `<p>${text}</p>`;
            })()
          }}
        />
      </Card.Body>
    </Card>
  </Col>
)}
        </Row>
      </Container>
    </div>
    
    </>
  );
}